module.exports = __webpack_public_path__ + "img/question-circle.0f448b24.svg";